import { ChangeDetectorRef, inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  // private readonly cdr= inject(ChangeDetectorRef);
  

  // Show loading spinner
  showLoading() {
    this.loadingSubject.next(true);
  }

  // Hide loading spinner
  hideLoading() {
    this.loadingSubject.next(false);
  }

  private isTableLoadingSubject = new BehaviorSubject<boolean>(false); // Default value: false
  isVisible$ = this.isTableLoadingSubject.asObservable(); // Expose as Observable

  toggleTableLoading() {
    setTimeout(() => {
      this.isTableLoadingSubject.next(!this.isTableLoadingSubject.value); // Toggle boolean value
      // this.cdr.detectChanges(); // manually trigger change detection
    }, 100); 
    
  }
}
